import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import * as analyticsActions from 'action/analytics'
import * as videoActions from 'action/video'
import { bindActionCreators } from 'redux'
import ContentHeader from 'component/utils/ContentHeader'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import MostAccessedView from 'component/analytics/MostAccessedView'
import VersionsView from 'component/analytics/VersionsView'
import AccessView from 'component/analytics/AccessView'
import VideosView from 'component/analytics/VideosView'
import Breadcrumb from 'component/Breadcrumb'

const TYPE_WEB = 1
const TYPE_MOBILE = 2

class AnalyticsContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    top5Mobile: PropTypes.array,
    top3Web: PropTypes.array,
    devices: PropTypes.object,
    users: PropTypes.object,
    video: PropTypes.object,
    fetchMostAccessedMenus: PropTypes.func.isRequired,
    fetchDevicesUpdate: PropTypes.func.isRequired,
    fetchActiveInactiveUsers: PropTypes.func.isRequired,
    fetchLatestVideoData: PropTypes.func.isRequired,
  }

  componentDidMount() {
    this.handleFetchMenusMobile()
    this.handleFetchMenusWeb()
    this.handleFetchDevices({ idBranches: [] })
    this.handleFetchUsers()
    this.handleFetchVideoData()
  }

  handleFetchVideoData = () => {
    const { auth, fetchLatestVideoData } = this.props

    fetchLatestVideoData(auth.user.dsToken)
  }

  handleFetchMenusMobile = (filters) => {
    const params = {
      ...filters,
      inMobile: true,
      limit: 5,
    }

    this.handleFetchMenus(params)
  }

  handleFetchMenusWeb = (filters) => {
    const params = {
      ...filters,
      inWeb: true,
      limit: 5,
    }

    this.handleFetchMenus(params)
  }

  handleFetchMenus = (params) => {
    const { auth, fetchMostAccessedMenus } = this.props

    fetchMostAccessedMenus(auth, params)
  }

  handleFetchDevices = (filters) => {
    const { auth, fetchDevicesUpdate } = this.props

    fetchDevicesUpdate(auth, filters)
  }

  handleFetchUsers = (filters) => {
    const { auth, fetchActiveInactiveUsers } = this.props

    fetchActiveInactiveUsers(auth, filters)
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('analytics.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const { translate, auth, top5Mobile, top3Web, devices, users, video } =
      this.props

    return (
      <section>
        <ContentHeader>{translate('analytics.title')}</ContentHeader>

        <section className='analytics-page'>
          {this.renderBreadcrumb()}

          <div className='container-fluid'>{/* Possible errors in here */}</div>

          <Row className='container-mobile container-flex'>
            <Col xs={12} sm={6} md={6} lg={4} lgOffset={2}>
              <div className='rectangle border rounded'>
                <MostAccessedView
                  user={auth.user}
                  translate={translate}
                  top5={top5Mobile}
                  title={translate('analytics.mostAccessedMobile')}
                  type={TYPE_MOBILE}
                  fetchMenus={this.handleFetchMenusMobile}
                />
              </div>
            </Col>

            <Col xs={12} sm={6} md={6} lg={4}>
              <div className='rectangle border rounded'>
                <MostAccessedView
                  user={auth.user}
                  translate={translate}
                  top5={top3Web}
                  title={translate('analytics.mostAccessedWeb')}
                  type={TYPE_WEB}
                  fetchMenus={this.handleFetchMenusWeb}
                />
              </div>
            </Col>
          </Row>

          <Row className='margin-bottom-double container-mobile container-flex'>
            <Col xs={12} sm={12} md={12} lg={8} lgOffset={2}>
              <Row>
                <Col xs={12} sm={6} md={6} lg={4}>
                  <div className='rectangle border rounded'>
                    <VersionsView
                      user={auth.user}
                      translate={translate}
                      data={devices}
                      fetchDevices={this.handleFetchDevices}
                    />
                  </div>
                </Col>

                <Col xs={12} sm={6} md={6} lg={4}>
                  <div className='rectangle border rounded'>
                    <AccessView translate={translate} data={users} />
                  </div>
                </Col>

                <Col xs={12} sm={6} md={6} lg={4}>
                  <div className='rectangle border rounded'>
                    <VideosView translate={translate} data={video} />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = ({ analyticsReducer, videosReducer }) => ({
  top5Mobile: analyticsReducer.menusMobile.record,
  top3Web: analyticsReducer.menusWeb.record,
  devices: analyticsReducer.devices.record,
  users: analyticsReducer.users.record,
  video: videosReducer.latest.record,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...analyticsActions, ...videoActions }, dispatch)

/*
 * Connects component to I18next
 */
const AnalyticsTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(AnalyticsContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsTranslated)

/*
 * Exports as component
 */
export { AnalyticsContainer as Analytics }
